import { ReactElement, useContext } from "react";
import { GuestAuthenticationContext } from "../contexts/guest-auth-context/GuestAuthContext";
import { MixPanelWrapper } from "./MixPanelWrapper";

export function MixPanelWrapperGuest(props: {children: ReactElement | ReactElement[]}): ReactElement {
    const {user} = useContext(GuestAuthenticationContext);
    return <MixPanelWrapper user={user} {...props}/>;
}